export const isLocal = process.env.LOCAL === 'true';
